import axios from "@/app/Axios";

class Login {

    async loginUser(user_email, user_password) {
        try {
            const response = await axios.post("/login", {
                email: user_email,
                password: user_password,
            });
            if (response.data.access_token === null) {
                return false;
            } else {
                localStorage.setItem("access_token", response.data.access_token);
                return true;
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                const errorData = error.response.data;
                return errorData;
            } else {
                console.error(error);
            }
        }
    }//loginUser

    /* async authVerification() {
        try {
            const response = await axios.post("/me");
            console.log("ACCESO", response);
            if (response.status === 200) {
                return true;
            }
        } catch (error) {
            console.log("ACCESO NO AUTORIZADO, DEBE INICIAR SESION");
        }
        return false;
    } */
    async authVerification() {
        try {
            const response = await axios.post("/me");
            //console.log("token nulo resposne", response);
            if (response.status === 200) {
                return true;
            } else{
                console.log("no autorizado");
            }
        } catch (error) {
            console.log("ACCESO NO AUTORIZADO, DEBE INICIAR SESION");
        }
        return false;
    }
    /* async authVerification() {
        const token = localStorage.getItem('access_token');
        // Realiza una solicitud al backend para verificar el token
        try {
          const response = await fetch('http://192.168.20.31:9077/api/me', {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          });
    
          if (response.ok) {
            const data = await response.json();
            console.log("Datos de usuario:", data);
            return true;
          } else {
            console.log("Error en la verificación del token:", response.status);
            return false;
          }
        } catch (error) {
          console.error("Error en la solicitud de verificación del token:", error);
          return false;
        }
      } */

    async authMe() {
        try {
            const response = await axios.post("/me");
            console.log("muestra los resultados a detalle del usuario del servicio", response);
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }


    async logout() {
        try {
            const response = await (axios.post("/logout"));
            if(response.data.status){
                console.log("logout", response.data.status)
                localStorage.removeItem("access_token");
            }
            return response.data;
        } catch (error) {
            console.log(error)
        }

    }
    async userme() {
        try {
            const response = await axios.get("/user");
            console.log("Este es el usuario logueado", response.data);
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }
    async primer_pass() {
        try {
            const response = await axios.get("/mostrar_datos_use_first_password");
            console.log("Este es el primer password del usuario", response.data);
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }
    async userroleauth() {
        try {
            const response = await axios.get("/userandrole");
            console.log("Este es el usuario logueado", response.data);
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }
    /* async logout() {
        try {
            const token = localStorage.getItem('access_token');
            const response = await axios.post("/logout", {}, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
    
            console.log("Response del logout:", response);
    
            if(response.data && response.data.status) {
                console.log("Logout exitoso", response.data.status);
                localStorage.removeItem("access_token");
            } else {
                console.log("Respuesta inesperada del logout:", response);
            }
    
            return response.data;
        } catch (error) {
            console.error("Error al cerrar sesión:", error);
    
            if (error.response) {
                // La solicitud fue hecha y el servidor respondió con un código de estado
                // que no está en el rango de 2xx
                console.log("Datos del error:", error.response.data);
                console.log("Estado del error:", error.response.status);
                console.log("Encabezados del error:", error.response.headers);
            } else if (error.request) {
                // La solicitud fue hecha pero no se recibió respuesta
                console.log("Solicitud del error:", error.request);
            } else {
                // Algo pasó al configurar la solicitud que desencadenó un error
                console.log("Error", error.message);
            }
    
            return { status: false, message: error.message };
        }
    } */
    
    
    
}


export default Login;

